import { Offer_Search as os, Offer_Suggest as ac } from "./backend"

const find = async (filter) => {
    let res = await os({
        searchRequest: filter
    });
    return res.data;
}

const suggest = async(tag) => {
    let { data } = await ac({
        tag: encodeURIComponent(tag)
    })
    return data;

}



export default {
    find,
    suggest
}